var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import moment from "moment";
import { BarChart, Bar, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from "recharts";
import Pill from "@irati/ui/src/Pill";
import { perkbox } from "@irati/ui/src/global/colors";
import { FormattedMessage } from "@irati/utils/lang";
import { StyledHr } from "../../../../containers/ReportingV2/styled";
import { LabelWrapper, TitleWrapper, StyledHeader, HeaderWrapper } from "../../styled/styled";
var REDEMPTION_WEEKS = 12;
var PerksActivityChart = /** @class */ (function (_super) {
    __extends(PerksActivityChart, _super);
    function PerksActivityChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPerksActivity = function (numberOfWeeks) {
            var redemptionDates = [];
            /* Getting the  dates of last 12 mondays */
            var firstMonday = moment()
                .isoWeekday(1)
                .subtract(numberOfWeeks, "weeks");
            for (var i = 0; i < numberOfWeeks; i++) {
                var date = "w/c " + firstMonday.add(1, "weeks").format("Do MMM");
                redemptionDates.push(date);
            }
            return redemptionDates;
        };
        _this.getRedemptionData = function () {
            var perksAndPerksGoMetrics = _this.props.perksAndPerksGoMetrics;
            var redemptions_12_weeks = perksAndPerksGoMetrics.redemptions_12_weeks;
            var redemptionsDates = _this.getPerksActivity(REDEMPTION_WEEKS) || [];
            return redemptionsDates.map(function (redemptionsDate, index) {
                return {
                    date: redemptionsDate,
                    count: redemptions_12_weeks[index]
                };
            });
        };
        _this.getDaysDifference = function () {
            var perksAndPerksGoMetrics = _this.props.perksAndPerksGoMetrics;
            var last_updated_date = perksAndPerksGoMetrics.last_updated_date;
            var lastUpdatedDate = moment(last_updated_date).startOf("day");
            var today = moment().startOf("day");
            var relativeDays = today.diff(lastUpdatedDate, "days");
            return relativeDays;
        };
        return _this;
    }
    PerksActivityChart.prototype.render = function () {
        var perksAndPerksGoMetrics = this.props.perksAndPerksGoMetrics;
        var redemptions_12_weeks = perksAndPerksGoMetrics.redemptions_12_weeks;
        var redemptionData = redemptions_12_weeks && this.getRedemptionData();
        var perksPackage = perksAndPerksGoMetrics.package;
        var lastUpdatedDay = this.getDaysDifference();
        return (React.createElement(React.Fragment, null,
            React.createElement(HeaderWrapper, null,
                React.createElement(StyledHeader, { bold: true },
                    React.createElement(FormattedMessage, { id: "admin.reportingV2.perks" })),
                React.createElement(Pill, { text: React.createElement(FormattedMessage, { id: "admin.reportingV2.perksActivity.lastUpdatedDate", values: { lastUpdatedDay: lastUpdatedDay } }) })),
            React.createElement(LabelWrapper, null,
                React.createElement(FormattedMessage, { id: "admin.reportingV2.perksActivityChart.package", values: { perksPackage: perksPackage } })),
            React.createElement(StyledHr, null),
            React.createElement(TitleWrapper, null,
                React.createElement(FormattedMessage, { id: "admin.reportingV2.perksActivityChart.title" })),
            React.createElement(ResponsiveContainer, { width: "100%", height: 250 },
                React.createElement(BarChart, { width: 1000, height: 250, data: redemptionData },
                    React.createElement(CartesianGrid, { vertical: false }),
                    React.createElement(XAxis, { dataKey: "date", tickLine: false, fontFamily: "Lato, sans-serif", fontSize: "10px", interval: 0, axisLine: false }),
                    React.createElement(YAxis, { dataKey: "count", tickLine: false, tickCount: 5, fontFamily: "Lato, sans-serif", fontSize: "10px" }),
                    React.createElement(Bar, { dataKey: "count", barSize: 50, fill: perkbox.blue })))));
    };
    return PerksActivityChart;
}(PureComponent));
export default PerksActivityChart;
